import { request } from '@/api/request'

export const authorizeAlipay = async (redirect: string, sku: string, currency: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('redirect', redirect);
  bodyFormData.set('sku', sku);
  bodyFormData.set('currency', currency);

  const { data } = await request.post('/webapi/purchase/me/authorize/alipay', bodyFormData)

  return data.value
}

export const authorizeWechat = async (redirect: string, sku: string, currency: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('redirect', redirect);
  bodyFormData.set('sku', sku);
  bodyFormData.set('currency', currency);

  const { data } = await request.post('/webapi/purchase/me/authorize/wechat', bodyFormData)

  return data.value
}

export const getStripeSession = async (redirect: string, cancel: string, sku: string, currency: string, paymentMethod: string) => {
  const bodyFormData = new FormData();
  bodyFormData.set('redirect', redirect);
  bodyFormData.set('cancel', cancel);
  bodyFormData.set('sku', sku);
  bodyFormData.set('currency', currency);
  bodyFormData.set('paymentMethod', paymentMethod);
  bodyFormData.set('image', 'https://webassets.lowiro.com/hikari.jpg')

  const { data } = await request.post('/webapi/purchase/me/stripe/v2/session', bodyFormData)

  return data.value
}

export const checkStripeStatus = async (requestId: string) => {
  const { data } = await request.get(`/webapi/purchase/me/stripe/session/${requestId}`)

  return data.value
}

export const getProducts = async () => {
  const { data } = await request.get(`/webapi/purchase/stripe/products/`)

  return data.value.sort((a: any, b: any) => a.total_memory > b.total_memory ? 1 : -1)
}